import script from "./StudentWrongQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentWrongQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./StudentWrongQuestion.vue?vue&type=style&index=0&id=97912adc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97912adc"]])

export default __exports__